import { GET_BLOG_POSTS } from './Blog.action';

export const initialState = {
    posts: [],      // always an array
    isLoading: true
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_BLOG_POSTS:
            return {
                ...state,
                posts: action.postsArray,
                isLoading: false
            };
        default:
            return state;
    }
};
